import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { IAPINewOrdersGraphDataModel, IAPINewOrdersModel } from "../interfaces";

 
 
export class NewOrdersModel {
    total: number;
    newOrdersAmount: number;
    lastOrder: Date | null;
    graphData: NewOrdersGraphDataModel[];
    constructor(data?: Partial<NewOrdersModel>) {
        this.total = data?.total || 0;
        this.newOrdersAmount = data?.newOrdersAmount || 0;
        this.lastOrder = data?.lastOrder || null;
        this.graphData = data?.graphData?.map((s) => new NewOrdersGraphDataModel(s)) || [];
    }

    static deserializeAPIModel(data: IAPINewOrdersModel): NewOrdersModel {
        const mappedData: Partial<NewOrdersModel> = {
            total: data.total,
            newOrdersAmount: data.newOrdersAmount,
            lastOrder: data.lastOrder ? UtilityMethods.removeZFromDateString(data.lastOrder) : null,
            graphData: data.graphData?.map((s) => NewOrdersGraphDataModel.deserializeAPIModel(s)) || [],
        };
        return new NewOrdersModel(mappedData);
    }
}
export class NewOrdersGraphDataModel {
    date: Date;
    total: number;
    label: string;
    constructor(data?: Partial<NewOrdersGraphDataModel>) {
        this.date = new Date(data?.date || '');
        this.total = data?.total || 0;
        this.label = UtilityMethods.formatDateInMonthAndDay(this.date);
    }

    static deserializeAPIModel(data: IAPINewOrdersGraphDataModel): NewOrdersGraphDataModel {
        const mappedData: Partial<NewOrdersGraphDataModel> = {
            date: UtilityMethods.removeZFromDateString(data.date),
            total: data.total,
        };
        return new NewOrdersGraphDataModel(mappedData);
    }
}
